import { render } from "./ArvoreDeHabilidades.vue?vue&type=template&id=7fabcea5&scoped=true"
import script from "./ArvoreDeHabilidades.vue?vue&type=script&lang=js"
export * from "./ArvoreDeHabilidades.vue?vue&type=script&lang=js"

import "./ArvoreDeHabilidades.vue?vue&type=style&index=0&id=7fabcea5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fabcea5"]])

export default __exports__